import axios from '../http/index'
const event = {
    namespaced: true,
    state: () => {
        return {
            indexType: "",
            launchWeapp: {
                show: false
            }
        }
    },
    getters: {
        indexType(state) {
            return state.indexType
        },
        getLaunchWeapp(state) {
            return state.launchWeapp
        }
    },
    mutations: {
        emit(state, res) {
            state[res.key] = res.data
        },
        setLaunchWeapp(state, data) {
            state.launchWeapp = data
        },
    },
    actions: {

    }
}
export default event


// WEBPACK FOOTER //
// ./src/store/event.js